import { useState } from "react"
import Aside from "../Aside"
import { CModal, Div, MenuAltRight } from "./style"

const Menu = () =>{
    const [openModal, setOpenModal] = useState(false)

    return(
        <>
        <Div>
            <CModal 
                open={openModal}
                onClose= {()=> setOpenModal(false)}
            >
                <>
                <button onClick={()=> setOpenModal(false)}>x</button>
                <Aside/>
                </>
            </CModal>
            <MenuAltRight onClick={()=> setOpenModal(true)}/>
        </Div>
        </>
    )
}

export default Menu